import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { translate } from "react-i18next";
import PhotoIcon from './../../../../../icons/image.svg';
import VideoIcon from './../../../../../icons/video.svg';
import DroneIcon from './../../../../../icons/drone.svg';
import FileIcon from './../../../../../icons/shp.svg';
import MapIcon from './../../../../../icons/map.svg';
import AttachmentIcon from './../../../../../icons/clip.svg';
import ModelIcon from './../../../../../icons/3d.svg';
import DTMIcon from './../../../../../icons/terrain.svg';
import shadeColor from './../../../../../utilities/shadeColor';
import {
    PHOTOS_TYPE,
    VIDEO_TYPE,
    SHP_TYPE,
    ORTO_TYPE,
    DTM_TYPE,
    MODEL_TYPE,
    RESOURCE_TYPE,
    DRONE_TYPE
} from '../../../../../types/upload';

const UploadTypeWrapper = styled.div`
  width: 100%;
`;
const CustomMarginParagraph = styled.p`
  margin: 15px 0 5px 0;
  white-space: pre-wrap;
`;
const StyledNavTabs = styled.div`  
  width: 100%;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;  
`;
const StyledNavItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;
  width: 40%;
  margin: 5px;
  color: white;
  cursor: pointer;
  border: 1.5px solid rgba(128,128,128,0.1);
  border-radius: 5px;
  :hover {
    background-color: ${ shadeColor('#265a9c', 0.2)} ;
  }

  pointer-events: ${props => props.disabled ? 'none' : 'auto'};   
  cursor: ${props => props.disabled ? 'default' : 'pointer'};   
  background-color: ${props => props.disabled ? shadeColor('#265a9c', 0.5) : '#265a9c'};
`;

class UploadTypeSelect extends React.Component {

    render() {
        const {
            onTypeSelect,
            chosenProject,
            t,
        } = this.props;
        const { license } = chosenProject;

        return (
            <UploadTypeWrapper>
                {
                    !license.videoEnabled
                        ? <CustomMarginParagraph>{t('In trial version you cannot upload video')}</CustomMarginParagraph>
                        : ''
                }
                <StyledNavTabs>
                    <StyledNavItem
                        title={t('SHP upload panel')}
                        onClick={() => {
                            onTypeSelect(SHP_TYPE)
                        }}>
                        <ReactSVG
                            path={FileIcon}
                            style={{
                                fill: '#a3bace',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        SHP
                    </StyledNavItem>
                    <StyledNavItem
                        title={t('Photo upload panel')}
                        onClick={() => {
                            onTypeSelect(PHOTOS_TYPE)
                        }}>
                        <ReactSVG
                            path={PhotoIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('Photos')}
                    </StyledNavItem>
                    <StyledNavItem
                        disabled={!license.videoEnabled}
                        title={t('Video upload panel')}
                        onClick={() => {
                            onTypeSelect(VIDEO_TYPE)
                        }}>
                        <ReactSVG
                            path={VideoIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('Videos')}
                    </StyledNavItem>
                    <StyledNavItem
                        title={t('Orthophotomap upload panel')}
                        onClick={() => {
                            onTypeSelect(ORTO_TYPE)
                        }}>
                        <ReactSVG
                            path={MapIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('Orthophotomap')}
                    </StyledNavItem>
                    <StyledNavItem
                        title={t('DTM upload panel')}
                        onClick={() => {
                            onTypeSelect(DTM_TYPE)
                        }}>
                        <ReactSVG
                            path={DTMIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('DTM')}
                    </StyledNavItem>
                    <StyledNavItem
                        title={t('Model upload panel')}
                        onClick={() => {
                            onTypeSelect(MODEL_TYPE)
                        }}>
                        <ReactSVG
                            path={ModelIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('Model')}
                    </StyledNavItem>
                    <StyledNavItem
                        title={t('Attachment upload panel')}
                        onClick={() => {
                            onTypeSelect(RESOURCE_TYPE)
                        }}>
                        <ReactSVG
                            path={AttachmentIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('Attachment')}
                    </StyledNavItem>
                    <StyledNavItem
                        title={t('DJI Log file upload panel')}
                        onClick={() => {
                            onTypeSelect(DRONE_TYPE)
                        }}>
                        <ReactSVG
                            path={DroneIcon}
                            style={{
                                fill: '#ffffff',
                                padding: '5px',
                                width: '30px',
                                height: '30px'
                            }}
                        />
                        {t('DJI log file')}
                    </StyledNavItem>
                </StyledNavTabs>
            </UploadTypeWrapper>
        );
    }
}

const mapStateToProps = state => ({
    chosenProject: state.auth.get('chosenProject'),
    roles: state.auth.get('roles'),
});

export default translate("translations")(connect(mapStateToProps)(UploadTypeSelect));



// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/uploadTypeSelect/UploadTypeSelect.jsx